import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { GroupDto } from '../../../../../core/dto/listtones/groupdto';
import { BaseContext } from '../../../../../utils/basecontext';
import { CreateGroupDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/creategroup/creategroupdto';
import { CreateGroupResponse } from 'src/com/sixdee/crbtportal/core/api/group/creategroup/creategroupresponse';
import { CreateGroupRequestImpl } from 'src/com/sixdee/crbtportal/core/api/group/creategroup/creategrouprequest';
import { EditGroupDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/editgroup/editgroupdto';
import { EditGroupResponse } from 'src/com/sixdee/crbtportal/core/api/group/editgrop/editgroupresponse';
import { EditGroupRequestImpl } from 'src/com/sixdee/crbtportal/core/api/group/editgrop/editgrouprequest';


export interface ManageGroupAPIModel extends APIModel
{
    onEditGroup(groupDto: GroupDto): void;
    onCreateGroup(groupDto: GroupDto): void;
}

export class ManageGroupAPIModelImpl extends APIModelImpl implements ManageGroupAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    onEditGroup(groupDto: GroupDto): void
    {
        console.log("editManageGroup() invoked");
  
        let editGroupDto = new EditGroupDtoImpl();
        editGroupDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        editGroupDto.setGroupName(groupDto.getGroupName());
        editGroupDto.setGroupId(+groupDto.getGroupId());
        editGroupDto.setGroupDesc("good edit");

        editGroupDto.setMemberDetails(groupDto.getMembersList());
        editGroupDto.setDeleteMember(groupDto.getDeletedMembersList().toString());
        editGroupDto.setToneDetails("14558");
        editGroupDto.setPriority("0");
        editGroupDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getGroupProcessorFactory()
        .getEditGroupAPIProcessor()
        .success((editGroupResponse: EditGroupResponse)=>
        {
            console.log("success() invoked ##########EDIT GROUP###############");

            this.getAPIModelHandler().onSuccess(editGroupResponse.getAPIFeature(), 
            editGroupResponse.getDescription(), editGroupResponse);
         })
        .failure((editGroupResponse: EditGroupResponse)=>
         {
           this.getAPIModelHandler().onFailure(editGroupResponse.getAPIFeature(), 
           editGroupResponse.getDescription(), undefined);
         })
        .execute(new EditGroupRequestImpl(editGroupDto));
    }

    onCreateGroup(groupDto: GroupDto): void
    {
        console.log("onCreateGroup() invoked");

        let createGroupDto = new CreateGroupDtoImpl();
        createGroupDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        createGroupDto.setGroupName(groupDto.getGroupName());
        createGroupDto.setGroupDesc("group");

        createGroupDto.setMemberDetails(groupDto.getMembersList());
        createGroupDto.setToneDetails("14558");
        createGroupDto.setPriority("0");

        this.getAPIProcesssorFactory().getGroupProcessorFactory()
        .getCreateGroupAPIProcessor()
        .success((createGroupResponse: CreateGroupResponse)=>
        {
            console.log("success() invoked ##########CREATE GROUP###############");

            this.getAPIModelHandler().onSuccess(createGroupResponse.getAPIFeature(), 
            createGroupResponse.getDescription(), createGroupResponse);
         })
        .failure((createGroupResponse: CreateGroupResponse)=>
         {
           this.getAPIModelHandler().onFailure(createGroupResponse.getAPIFeature(), 
           createGroupResponse.getDescription(), undefined);
         })
        .execute(new CreateGroupRequestImpl(createGroupDto));
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/managegroupapimodel.ts